import React, { useMemo } from "react";
import { Autocomplete, Divider, ListSubheader, TextField } from "@mui/material";

const LocaleSelector = ({
  localesNameList,
  frequentLocales,
  selectedLocale,
  setSelectedLocale,
}) => {
  const frequentSet = useMemo(() => new Set(frequentLocales), [frequentLocales]);

  // Order: frequents first, then the rest
  const allOptions = useMemo(() => {
    const frequentOrdered = frequentLocales.filter((n) =>
      localesNameList.includes(n)
    );
    const othersOrdered = localesNameList.filter((n) => !frequentSet.has(n));
    return [...frequentOrdered, ...othersOrdered];
  }, [localesNameList, frequentLocales, frequentSet]);

  return (
    <Autocomplete
      fullWidth
      disablePortal
      options={allOptions}
      value={selectedLocale}
      onChange={(_, newValue) => setSelectedLocale(newValue)}
      groupBy={(option) => (frequentSet.has(option) ? "0_Fréquentes" : "1_Toutes les autres")}
      renderGroup={(params) => (
        <li key={params.key}>
          <ListSubheader>{params.group.slice(2)}</ListSubheader>
          {params.children}
          {params.group.startsWith("0_") && <Divider sx={{ my: 1 }} />}
        </li>
      )}
      renderInput={(params) => <TextField {...params} label="Sélectionner une langue" />}
    />
  );
};

export default React.memo(LocaleSelector);
